module.exports = "/img/65c4c10ac73de9170fc9674082597030.svg";